import { render, staticRenderFns } from "./LandingText.vue?vue&type=template&id=f0d6fe0e&scoped=true&"
import script from "./LandingText.vue?vue&type=script&lang=js&"
export * from "./LandingText.vue?vue&type=script&lang=js&"
import style0 from "./LandingText.vue?vue&type=style&index=0&id=f0d6fe0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0d6fe0e",
  null
  
)

export default component.exports